import { applyMiddleware, compose, createStore, StoreEnhancer } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { PersistConfig, persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";

import { createRootReducer } from "./reducers";
import {
  ProgramsConductorSaga,
  ArchiveListSaga,
  ConfigInitSaga,
  UserSessionSaga,
  ContactUsSaga,
  TvSaga,
  ProgramViewSaga,
  PackagesSaga,
  ReportProblemSaga,
  PagesSaga,
  MessageModalSaga,
  ProfileDataSaga,
  SliderSaga,
} from "./sagas";
import { DevService } from "src/services";

export * from "./actions";
export * from "./reducers";
export * from "./sagas";
export * from "./types";
export * from "./models";

export const history = createBrowserHistory();

export const ConfigStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const doCompose: <StoreExt>(
    ...funcs: Array<StoreEnhancer<StoreExt>>
  ) => StoreEnhancer<StoreExt> = DevService.isDev()
    ? composeWithDevTools
    : compose;

  const enhancers = doCompose(
    applyMiddleware(sagaMiddleware),
    applyMiddleware(routerMiddleware(history))
  );

  const persistConfig: PersistConfig<any, any, any, any> = {
    key: "root",
    storage,
    whitelist: ["UserState", "HttpCacheState"],
    blacklist: [
      "ProgramsConductorState",
      "ConfigState",
      "ArchiveListState",
      "ModalsState",
      "ContactState",
      "TvState",
      "ProgramViewState",
      "PackagesState",
      "router",
      "ReportState",
      "PagesState",
      "MessageModalsState",
      "ProfileDataState",
    ],
  };

  const persistedReducer = persistReducer(
    persistConfig,
    createRootReducer(history)
  );

  const store = createStore(persistedReducer, enhancers);
  const persistor = persistStore(store);

  sagaMiddleware.run(ProgramsConductorSaga);
  // sagaMiddleware.run(SliderSaga)
  sagaMiddleware.run(ArchiveListSaga);
  sagaMiddleware.run(ConfigInitSaga);
  sagaMiddleware.run(UserSessionSaga);
  sagaMiddleware.run(ContactUsSaga);
  sagaMiddleware.run(TvSaga);
  sagaMiddleware.run(ProgramViewSaga);
  sagaMiddleware.run(PackagesSaga);
  sagaMiddleware.run(ReportProblemSaga);
  sagaMiddleware.run(PagesSaga);
  sagaMiddleware.run(MessageModalSaga);
  sagaMiddleware.run(ProfileDataSaga);

  return { store, persistor };
};

export const store = ConfigStore();
